import ai2Icon from "@/assets/img/icon_board-ai2.webp";
import aimgIcon from "@/assets/img/icon_board-aimg.webp";
import darkIcon from "@/assets/img/icon_board-dark.webp";
import goreIcon from "@/assets/img/icon_board-gore.webp";
import longIcon from "@/assets/img/icon_board-long.webp";
import operationsIcon from "@/assets/img/icon_board-operations.webp";
import { getBoardPresentations } from "@/config/boardPresentation";

const BOARD_ICONS: Readonly<Record<string, string>> = Object.freeze({
  ai2: ai2Icon,
  aimg: aimgIcon,
  dark: darkIcon,
  gore: goreIcon,
  long: longIcon,
  operations: operationsIcon,
});

/** slugに対応する板アイコンが存在する場合だけ、その画像URLを返す。 */
export function resolveBoardIcon(
  slug: string | null | undefined,
): string | null {
  return slug === null || slug === undefined
    ? null
    : Object.hasOwn(getBoardPresentations(), slug)
      ? (getBoardPresentations()[slug]?.imageUrl ?? null)
      : (BOARD_ICONS[slug] ?? null);
}
